module.exports = __webpack_public_path__ + "static/media/error.23edf22f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/error.mp3
// module id = 42
// module chunks = 1